import {
  Bar,
  BarChart,
  CartesianGrid,
  ReferenceArea,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import type { MonthCloseProjection } from '../../lib/api.js';
import { AXIS, GRID, TOOLTIP_STYLE } from './ChartCard.js';

/** Projection "fan": MTD vs run-rate vs seasonal close, with the band shaded (chart #8). */
export function ProjectionFanChart({ p }: { p: MonthCloseProjection }) {
  const data = [
    { name: 'MTD', value: Math.round(p.mtd) },
    { name: 'Run-rate', value: Math.round(p.runRate.value ?? 0) },
    { name: 'Estacional', value: Math.round(p.seasonal.value ?? 0) },
  ];
  const low = p.seasonal.bandLow ?? null;
  const high = p.seasonal.bandHigh ?? null;

  return (
    <ResponsiveContainer width="100%" height={260}>
      <BarChart data={data} margin={{ top: 8, right: 12, bottom: 8, left: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke={GRID} />
        <XAxis dataKey="name" tick={AXIS} />
        <YAxis tick={AXIS} />
        <Tooltip contentStyle={TOOLTIP_STYLE} />
        {low != null && high != null && (
          <ReferenceArea
            y1={low}
            y2={high}
            fill="#22c55e"
            fillOpacity={0.12}
            ifOverflow="extendDomain"
          />
        )}
        <Bar dataKey="value" name="Valor" fill="#3b82f6" radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
